import React, {
  createContext, ReactNode, useCallback, useMemo, useState,
} from 'react';

type ModalType = 'error' | 'success' | 'warning' | '';

export const ModalErrorContext = createContext( {
  showModal: false,
  title: '',
  description: '',
  modalType: 'error' as ModalType,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  openErrorModal: ( description: string, modalType?: ModalType, newTitle?: string ) => {},
  closeErrorModal: () => {},
} );

function ModalErrorProvider( { children }: { children: ReactNode } ) {
  const [showModal, setShowModal] = useState( false );
  const [description, setDescription] = useState( '' );
  const [title, setTitle] = useState( '' );
  const [modalType, setModalType] = useState<ModalType>( '' );

  const openErrorModal = useCallback( ( desc: string, kind: ModalType = 'error', newTitle?: string ) => {
    if ( newTitle ) setTitle( newTitle );
    setDescription( desc );
    setModalType( kind );
    setShowModal( true );
  }, [] );

  const closeErrorModal = useCallback( () => {
    setTitle( '' );
    setDescription( '' );
    setShowModal( false );
    setModalType( '' );
  }, [] );

  const value = useMemo( () => ( {
    description,
    title,
    showModal,
    modalType,
    openErrorModal,
    closeErrorModal,
  } ), [description, showModal, modalType] );

  return (
    <ModalErrorContext.Provider value={value}>
      {children}
    </ModalErrorContext.Provider>
  );
}

export default ModalErrorProvider;
